<template>
    <div v-if="item.children" class="flex items-stretch py-10">
        <div
            v-for="(column, i) in childrenColumns"
            :key="`${item.label}_col${i}`"
            class="flex flex-col gap-10 flex-grow-1 px-10 border-r-1 border-slate-700 last:border-r-0"
        >
            <div v-for="child in column" :key="child.label">
                <div class="text-slate-100 uppercase text-xs font-semibold mb-4">
                    <a
                        v-if="child.to"
                        class="block cursor-pointer hover:underline"
                        href="{{ child.to }}"
                        >{{ child.label }}</a
                    >
                    <span v-else>{{ child.label }}</span>
                </div>
                <div class="flex flex-col gap-3">
                    <div
                        v-for="grandchild in child.children"
                        :key="`${child.label}_${grandchild.label}`"
                        class="text-white text-base"
                    >
                        <a class="blockcursor-pointer hover:underline" href="{{ grandchild.to }}">
                            {{ grandchild.label }}
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import type { NavigationMenuItem } from '@nuxt/ui'

const props = defineProps<{
    item: NavigationMenuItem
}>()

/**
 * Break the children into 3 arrays of arrays to handle cases where
 * there are more than 3 children.
 */
const childrenColumns = computed(() => {
    if (!props.item.children) return []
    const columns: NavigationMenuItem['children'][] = []

    // Add each child to the appropriate column
    props.item.children.forEach((child, index) => {
        const columnIndex = index % 3
        if (!columns[columnIndex]) columns[columnIndex] = []
        columns[columnIndex].push(child)
    })
    return columns
})
</script>
